import { createAction, props } from '@ngrx/store';

export const addMainOutletRoute = createAction('[Navigation History] Add Last Page', props<{ lastPage: string }>());
